import { render } from "./MattersArisingReport.vue?vue&type=template&id=d886ad06&scoped=true"
import script from "./MattersArisingReport.vue?vue&type=script&lang=js"
export * from "./MattersArisingReport.vue?vue&type=script&lang=js"

import "./MattersArisingReport.vue?vue&type=style&index=0&id=d886ad06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d886ad06"]])

export default __exports__